// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApplyVelocityModel__container___ZFfdg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 32rem;

    border-right: 0.1rem solid var(--color-bg-border);
}

.ApplyVelocityModel__wrapper___DUnSd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.8rem 1.2rem;
}

.ApplyVelocityModel__body___kGF0R {
    border-color: var(--color-control-bg-border-default);
}

.ApplyVelocityModel__objectsRecalculate___TBIBy {
    display: flex;
    justify-content: space-between;

    margin: 0.8rem 1.2rem 0.4rem;
    padding-bottom: 0.4rem;

    border-bottom: var(--control-border-width) solid var(--color-bg-stripe);
}

.ApplyVelocityModel__recalculateText___J3MQ2 {
    display: flex;
    flex-grow: 1;
    align-items: center;
}

.ApplyVelocityModel__container___ZFfdg .ApplyVelocityModel__capObjectList___b1H_H {
    color: var(--color-control-typo-placeholder);
}

.ApplyVelocityModel__container___ZFfdg .ApplyVelocityModel__btnAsText___JZ45G {
    padding: 0;
    background-color: var(--color-control-bg-default);
}

.ApplyVelocityModel__object___Dh9vV {
    border-radius: var(--control-radius);
}

.ApplyVelocityModel__object___Dh9vV:hover {
    cursor: pointer;
    background: var(--color-control-bg-ghost);
}

.ApplyVelocityModel__object___Dh9vV:hover .ApplyVelocityModel__btnHidden___t6jN5 {
    visibility: visible;
}

.ApplyVelocityModel__gsm___kmiFC {
    line-height: 2.4rem;
}

.ApplyVelocityModel__btnIntroduction___jXfBR {
    margin-right: 0.4rem;
}

.ApplyVelocityModel__buttonsWrapper___vAye0 {
    margin: 0.4rem 1.2rem;
}

.ApplyVelocityModel__btnSelectAll___FPCMo {
    margin-right: 1.6rem;
}

.ApplyVelocityModel__cardWrapper___CeNvg {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    margin-right: 1.2rem;
    margin-bottom: 0.8rem;
    margin-left: 1.2rem;
}

.ApplyVelocityModel__objectListWrapper____OKZJ {
    display: flex;
    flex-direction: column;
}

.ApplyVelocityModel__iconIntroduction___XWeqS {
    margin-left: 0.4rem;
}

.ApplyVelocityModel__btnApply___TtDsq {
    margin: 0.4rem 1.2rem 0.8rem;
}

.ApplyVelocityModel__selectSpeedModelWrapper____ZDM_ {
    margin: 1.2rem;
}

.ApplyVelocityModel__objectWrapper___swham {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.4rem;
}

.ApplyVelocityModel__objectCheck___AKbrL {
    display: flex;
    margin-left: 0.8rem;
}

.ApplyVelocityModel__twtWrapper___Le5Yg {
    display: flex;
    flex-grow: 1;
    align-items: center;
}

.ApplyVelocityModel__twtIcon___gCu_m {
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
    margin-left: 0.8rem;
}

.ApplyVelocityModel__twtText___b6zjE {
    margin-right: 0.4rem;
    margin-left: 0.8rem;
    line-height: 2.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ApplyVelocityModel/ApplyVelocityModel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;IAE9B,YAAY;;IAEZ,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B,4BAA4B;IAC5B,sBAAsB;;IAEtB,uEAAuE;AAC3E;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,UAAU;IACV,iDAAiD;AACrD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;;IAEZ,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    width: 32rem;\n\n    border-right: 0.1rem solid var(--color-bg-border);\n}\n\n.wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0.8rem 1.2rem;\n}\n\n.body {\n    border-color: var(--color-control-bg-border-default);\n}\n\n.objectsRecalculate {\n    display: flex;\n    justify-content: space-between;\n\n    margin: 0.8rem 1.2rem 0.4rem;\n    padding-bottom: 0.4rem;\n\n    border-bottom: var(--control-border-width) solid var(--color-bg-stripe);\n}\n\n.recalculateText {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n}\n\n.container .capObjectList {\n    color: var(--color-control-typo-placeholder);\n}\n\n.container .btnAsText {\n    padding: 0;\n    background-color: var(--color-control-bg-default);\n}\n\n.object {\n    border-radius: var(--control-radius);\n}\n\n.object:hover {\n    cursor: pointer;\n    background: var(--color-control-bg-ghost);\n}\n\n.object:hover .btnHidden {\n    visibility: visible;\n}\n\n.gsm {\n    line-height: 2.4rem;\n}\n\n.btnIntroduction {\n    margin-right: 0.4rem;\n}\n\n.buttonsWrapper {\n    margin: 0.4rem 1.2rem;\n}\n\n.btnSelectAll {\n    margin-right: 1.6rem;\n}\n\n.cardWrapper {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    margin-right: 1.2rem;\n    margin-bottom: 0.8rem;\n    margin-left: 1.2rem;\n}\n\n.objectListWrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.iconIntroduction {\n    margin-left: 0.4rem;\n}\n\n.btnApply {\n    margin: 0.4rem 1.2rem 0.8rem;\n}\n\n.selectSpeedModelWrapper {\n    margin: 1.2rem;\n}\n\n.objectWrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.4rem;\n}\n\n.objectCheck {\n    display: flex;\n    margin-left: 0.8rem;\n}\n\n.twtWrapper {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n}\n\n.twtIcon {\n    margin-top: 0.4rem;\n    margin-bottom: 0.4rem;\n    margin-left: 0.8rem;\n}\n\n.twtText {\n    margin-right: 0.4rem;\n    margin-left: 0.8rem;\n    line-height: 2.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ApplyVelocityModel__container___ZFfdg`,
	"wrapper": `ApplyVelocityModel__wrapper___DUnSd`,
	"body": `ApplyVelocityModel__body___kGF0R`,
	"objectsRecalculate": `ApplyVelocityModel__objectsRecalculate___TBIBy`,
	"recalculateText": `ApplyVelocityModel__recalculateText___J3MQ2`,
	"capObjectList": `ApplyVelocityModel__capObjectList___b1H_H`,
	"btnAsText": `ApplyVelocityModel__btnAsText___JZ45G`,
	"object": `ApplyVelocityModel__object___Dh9vV`,
	"btnHidden": `ApplyVelocityModel__btnHidden___t6jN5`,
	"gsm": `ApplyVelocityModel__gsm___kmiFC`,
	"btnIntroduction": `ApplyVelocityModel__btnIntroduction___jXfBR`,
	"buttonsWrapper": `ApplyVelocityModel__buttonsWrapper___vAye0`,
	"btnSelectAll": `ApplyVelocityModel__btnSelectAll___FPCMo`,
	"cardWrapper": `ApplyVelocityModel__cardWrapper___CeNvg`,
	"objectListWrapper": `ApplyVelocityModel__objectListWrapper____OKZJ`,
	"iconIntroduction": `ApplyVelocityModel__iconIntroduction___XWeqS`,
	"btnApply": `ApplyVelocityModel__btnApply___TtDsq`,
	"selectSpeedModelWrapper": `ApplyVelocityModel__selectSpeedModelWrapper____ZDM_`,
	"objectWrapper": `ApplyVelocityModel__objectWrapper___swham`,
	"objectCheck": `ApplyVelocityModel__objectCheck___AKbrL`,
	"twtWrapper": `ApplyVelocityModel__twtWrapper___Le5Yg`,
	"twtIcon": `ApplyVelocityModel__twtIcon___gCu_m`,
	"twtText": `ApplyVelocityModel__twtText___b6zjE`
};
export default ___CSS_LOADER_EXPORT___;
